import {useCallback} from 'react';
import updateQuizQuestionAnswerDoc from '../../api/quizSession/updateQuizQuestionAnswerDoc';
import {firebaseAuth} from '../../config/firebase';
import {useFunctionWrap} from '../helper/function/useFunctionWrap';

export default function useUpdateQuestionAnswer() {
  const updateFn = useCallback(async (sessionId: string, questionId: string, selectedAnswer: string) => {
    const uid = firebaseAuth.currentUser?.uid;
    if (!uid) throw new Error('Not authenticated');
    return updateQuizQuestionAnswerDoc(uid, sessionId, questionId, selectedAnswer);
  }, []);

  const {fn, loading, error} = useFunctionWrap(updateFn);

  return {
    updateQuestionAnswer: fn,
    loading,
    error,
  };
}
